import { DetailsEditor, FormContainer } from "uikit"
import FaqLinks from "components/FaqLinks"
import React from "react"
import { Button, Dropdown, Grid } from "semantic-ui-react"
import { propertyTypes } from "./propertyTypes"
import { useStore } from "store"

const PropertyTypeSelectGrid = ({
  data: {
    fields: { propertyType },
    onSubmit,
    hasError,
    error
  },
  submitLabel = "Continue",
  onCancel
}) => {
  const [{ label, description, faqs }] = useStore(
    "contextuals",
    `Screen: addproperty`
  )

  return (
    <DetailsEditor
      heading={label}
      description={description}
      supplement={<FaqLinks items={faqs} />}
    >
      <Grid>
        <Grid.Row
          style={{
            background: "#edf7ff",
            padding: "3em",
            borderTop: "1px solid #ccc"
          }}
        >
          <Grid.Column textAlign="center">
            <Dropdown
              placeholder="Select Property Type"
              search
              selection
              options={[
                { value: "realestate", text: "Real Estate" },
                { value: "car", text: "Car" }
              ]}
              {...propertyType}
              error={!!propertyType.error}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered style={{ minHeight: "20em" }}>
          <Grid.Column
            width={10}
            textAlign="center"
            style={{ fontSize: "16px", paddingTop: "21px", color: "#aaa" }}
          >
            {propertyType.value
              ? propertyTypes[propertyType.value].description
              : "Please select the type of property you wish to add."}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
          <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
            <Button basic content="Cancel" onClick={onCancel} primary />
          </Grid.Column>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button content={submitLabel} onClick={onSubmit} primary />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </DetailsEditor>
  )
}

const PropertySelector = FormContainer(
  {
    propertyType: {
      type: "string",
      required: true
    }
  },
  (fields, ...form) => {}
)(PropertyTypeSelectGrid)

export default PropertySelector
